import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tp-course-filter-area tp-course-filter-bg p-relative pt-180 pb-220" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "tp-breadcrumb__content-filter mb-50" }
const _hoisted_6 = { class: "tp-breadcrumb__list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "14",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.07207 0C8.19331 0 8.31107 0.0404348 8.40664 0.114882L16.1539 6.14233L15.4847 6.98713L14.5385 6.25079V12.8994C14.538 13.1843 14.4243 13.4574 14.2225 13.6589C14.0206 13.8604 13.747 13.9738 13.4616 13.9743H2.69231C2.40688 13.9737 2.13329 13.8603 1.93146 13.6588C1.72962 13.4573 1.61597 13.1843 1.61539 12.8994V6.2459L0.669148 6.98235L0 6.1376L7.7375 0.114882C7.83308 0.0404348 7.95083 0 8.07207 0ZM8.07694 1.22084L2.69231 5.40777V12.8994H13.4616V5.41341L8.07694 1.22084Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "color" }
const _hoisted_9 = { class: "tp-breadcrumb__title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "tp-filter-mt-2" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_14 = {
  class: "tab-pane fade show active",
  id: "courses-grid",
  role: "tabpanel",
  "aria-labelledby": "courses-grid-tab"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = {
  key: 0,
  class: "col-lg-12 col-md-12 animate__animated animate__zoomIn"
}
const _hoisted_17 = {
  class: "tp-course-item p-relative fix mb-30 d-flex align-items-center justify-content-center",
  style: {"height":"380px"}
}
const _hoisted_18 = { class: "tp-error-wrapper text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", { class: "tp-error-title" }, "Oops!", -1 /* HOISTED */)
const _hoisted_20 = { class: "tp-error-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", { class: "tp-error-title-sm" }, "Not Data Found...", -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-course-item p-relative fix mb-30 placeholder-glow\"><div class=\"tp-course-teacher mb-15\"><div class=\"d-flex align-items-center gap-1\"><span class=\"placeholder d-inline-block rounded-circle\" style=\"width:30px;height:30px;\"></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span></div></div><div class=\"tp-course-thumb\"><span class=\"placeholder d-block rounded\" style=\"height:200px;\"></span></div><div class=\"tp-course-content\"><div class=\"d-flex align-items-center gap-1 mb-10\"><span class=\"placeholder d-inline-block rounded\" style=\"width:100px;height:25px;\"></span></div><div class=\"tp-course-meta\"><div class=\"d-flex align-items-center gap-1\"><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\"></span></div></div><span class=\"placeholder d-block rounded mt-4 mb-1\" style=\"width:80%;height:6px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:30%;height:6px;\"></span></div></div>", 1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  class: "tab-pane fade",
  id: "courses-list",
  role: "tabpanel",
  "aria-labelledby": "courses-grid-tab"
}
const _hoisted_25 = { class: "tp-course-filter-thumb" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "tp-course-filter-content" }
const _hoisted_28 = { class: "tp-course-filter-tag d-flex align-items-center justify-content-between mb-10" }
const _hoisted_29 = { class: "tag-span" }
const _hoisted_30 = { class: "tp-course-rating-star" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, " /5", -1 /* HOISTED */)
const _hoisted_32 = { class: "tp-course-rating-icon" }
const _hoisted_33 = { class: "course-star-rating" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\"><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i></div>", 1)
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i><i class=\"fa fa-star\"></i>", 5)
const _hoisted_40 = [
  _hoisted_35
]
const _hoisted_41 = { class: "tp-course-filter-title" }
const _hoisted_42 = { class: "tp-course-filter-meta" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.46118 2.81787V12.4506",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "15",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_47 = { class: "tp-course-filter-p" }
const _hoisted_48 = { class: "tp-course-filter-pricing d-flex align-items-center justify-content-between" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "tp-course-filter-btn" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CourseWidget = _resolveComponent("CourseWidget")

  return (_openBlock(), _createElementBlock("main", null, [
    _createCommentVNode(" course filter start "),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: { name: 'home' } }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString($data.category?.category_name), 1 /* TEXT */)
              ]),
              _createElementVNode("h3", _hoisted_9, _toDisplayString($data.category?.category_name), 1 /* TEXT */),
              ($data.category?.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($data.category?.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course filter end "),
    _createCommentVNode(" course filter area start "),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (!$data.courses.loading && !$data.courses.list.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("p", null, [
                            _createTextVNode("Sorry, we couldn't find any courses like "),
                            _createElementVNode("b", null, _toDisplayString($data.filters.search), 1 /* TEXT */),
                            _createTextVNode(".")
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "tp-btn-inner",
                            onClick: _cache[0] || (_cache[0] = $event => ($data.search_value=''))
                          }, _toDisplayString($data.lms_website.__('Show All Courses')), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!$data.courses.loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.courses.list, (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6 animate__animated animate__zoomIn",
                      key: course.name
                    }, [
                      _createVNode(_component_CourseWidget, { course: course }, null, 8 /* PROPS */, ["course"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($data.courses.loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.range(1, 3), (number) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6",
                      key: number
                    }, _hoisted_23))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courses.list, (course) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tp-course-filter-item mb-25 d-flex animate__animated animate__zoomIn",
                key: course.name
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_router_link, {
                    to: `/courses/view/${course.name}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "course-sky",
                        src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                        alt: course.title
                      }, null, 8 /* PROPS */, _hoisted_26)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(course.tags), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(course.avg_rating), 1 /* TEXT */),
                        _hoisted_31
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", {
                            class: "front-stars",
                            style: _normalizeStyle('width:'+$options.avg_rating_width(course.avg_rating))
                          }, _hoisted_40, 4 /* STYLE */)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("h4", _hoisted_41, [
                    _createVNode(_component_router_link, {
                      to: `/courses/view/${course.name}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.clip(course.title, 75)), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    (course.instructor?.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                          _createElementVNode("img", {
                            src: (course.instructor.user_image)?course.instructor.user_image:'/assets/lms_website/images/user.png',
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_44),
                          _createTextVNode(" " + _toDisplayString(course.instructor?.full_name), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", null, [
                      _hoisted_45,
                      _createTextVNode(" " + _toDisplayString(course.lesson_count) + " Lessons ", 1 /* TEXT */)
                    ]),
                    _createElementVNode("span", null, [
                      _hoisted_46,
                      _createTextVNode(" " + _toDisplayString(course.enrollment_count) + " Student ", 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("p", null, _toDisplayString($options.clip(course.short_introduction, 140)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    (!course.paid_course)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Free"))
                      : _createCommentVNode("v-if", true),
                    (course.paid_course)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($options.format_currency(course.course_price)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_router_link, {
                        to: `/courses/view/${course.name}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($data.lms_website.__('Preview this Course')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                    ])
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course filter area end ")
  ]))
}